import type { SetupTourDefinition } from '../core/types';
import { ROUTES } from '@/constants';

export const KM_POLICIES_SETUP_TOUR_TARGETS = {
  grid: 'km-policy-grid',
} as const;

// The backend counts this guide as a tour (hasTour), so the grid keeps a one-step tour.
export const kmPoliciesSetupTour: SetupTourDefinition = {
  id: 'km_policies_setup',
  label: 'Km limits',
  onboardingKey: 'km_policies_setup',
  steps: [
    {
      id: 'km-grid',
      route: ROUTES.KM_POLICIES,
      target: KM_POLICIES_SETUP_TOUR_TARGETS.grid,
      content:
        'Each row is a vehicle group and each column a season. A cell holds the km included per day and the price per extra km; an empty cell is Unlimited. Click a cell to set it.',
      next: {
        label: 'Done',
        completesTour: true,
      },
    },
  ],
};
